import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { ChargeUserInput } from '@/models/payment';

export const chargeUser = async (input: ChargeUserInput): Promise<string | null> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation ChargeUser(
        $currency: String!
        $amount: Float!
        $category: Float!
        $phoneNumber: String!
        $notes: String!
        $requestId: String
        $scheduledRideId: Float
        $deliveryOrderId: String
        $groceryOrderId: String
        $skipReceiptEmail: Boolean
        $requireDeliveryOrderId: Boolean
      ) {
        chargeUser(
          currency: $currency
          amount: $amount
          category: $category
          phoneNumber: $phoneNumber
          notes: $notes
          requestId: $requestId
          scheduledRideId: $scheduledRideId
          deliveryOrderId: $deliveryOrderId
          groceryOrderId: $groceryOrderId
          skipReceiptEmail: $skipReceiptEmail
          requireDeliveryOrderId: $requireDeliveryOrderId
        )
      }
    `),
    variables: input,
  });

  return response.data?.chargeUser ?? null;
};
